import { CitizenNationality } from 'common/schema/Citizen';
import { yup } from 'common/validation/initYup';

// Registrazione utente cittadino
export const citizenRegisterValidator = yup
  .object({
    nationality: yup
      .string()
      .required()
      .oneOfEnum(CitizenNationality)
      .oneOf(
        [CitizenNationality.ExtraEU],
        'I Cittadini Europei non possono registrarsi. Accedere con SPID / CIE / eIDAS.'
      ) as yup.StringSchema<CitizenNationality>,
    email: yup.string().email().lowercase().required(),
    password: yup.string().required(),
    confirmPassword: yup
      .string()
      .label('Conferma Password')
      .required()
      .when(['password'], (password: string, schema: yup.StringSchema) =>
        schema.test({
          name: 'check-password',
          message: `Le password non coincidono.`,
          exclusive: true,
          test: value => {
            if (!value || typeof value !== 'string') return false;
            return value === password;
          }
        })
      ),
    name: yup.string().required(),
    familyName: yup.string().required(),
    fiscalNumber: yup.string().required(), // TODO Validazione codice fiscale
    mobilePhone: yup.string().nullable().notRequired(),
    dateOfBirth: yup.date().notRequired(), // TODO HI Gestire `dateOnly`
    placeOfBirth: yup.string().required(),
    countyOfBirth: yup.string().required(), // TODO Validatori
    privacyAcceptance: yup
      .boolean()
      .required('È necessario accettare la privacy policy')
      .oneOf([true], 'È necessario accettare la privacy policy'),
    country: yup
      .string()
      .when('nationality', (nationality: CitizenNationality, schema: any) =>
        nationality === CitizenNationality.ExtraEU
          ? schema
              .required()
              .typeError('La nazionalità è un campo obbligatorio')
          : schema.notRequired().nullable()
      )
      .label('Paese di provenienza')
  })
  .noUnknown()
  .required();

export type ICitizenRegisterDto = yup.InferType<
  typeof citizenRegisterValidator
>;

// Modifica profilo cittadino
// TODO Rimuovere duplicazione dei campi
export const citizenEditValidator = yup
  .object({
    nationality: yup
      .string()
      .required()
      .oneOfEnum(CitizenNationality) as yup.StringSchema<CitizenNationality>,
    name: yup.string().required(),
    familyName: yup.string().required(),
    fiscalNumber: yup.string().required(), // TODO Validazione codice fiscale
    mobilePhone: yup.string().nullable().notRequired(),
    dateOfBirth: yup.date().nullable().notRequired(), // TODO HI Gestire `dateOnly`
    placeOfBirth: yup.string().required(),
    countyOfBirth: yup.string().required(), // TODO Validatori
    country: yup
      .string()
      .when('nationality', (nationality: CitizenNationality, schema: any) =>
        nationality === CitizenNationality.ExtraEU
          ? schema
              .required()
              .typeError('La nazionalità è un campo obbligatorio')
          : schema.notRequired().nullable()
      )
      .label('Paese di provenienza')
  })
  .noUnknown()
  .required();

export type ICitizenEditDto = yup.InferType<typeof citizenEditValidator>;

// Attivazione e-mail
export const citizenActivateValidator = yup
  .object({
    activationToken: yup
      .string()
      .required('È necessario fornire il codice di attivazione')
  })
  .noUnknown()
  .required();

export type ICitizenActivateDto = yup.InferType<
  typeof citizenActivateValidator
>;

// Richiesta recupero password
export const citizenRequestResetValidator = yup
  .object({
    email: yup.string().email().required()
  })
  .noUnknown()
  .required();

export type ICitizenRequestResetDto = yup.InferType<
  typeof citizenRequestResetValidator
>;

// Reimposta password
export const citizenResetValidator = yup
  .object({
    token: yup.string().required(),
    password: yup.string().label('Password').required(),
    confirmPassword: yup
      .string()
      .label('Conferma Password')
      .required()
      .when(['password'], (password: string, schema: yup.StringSchema) =>
        schema.test({
          name: 'check-password',
          message: `Le password non coincidono.`,
          exclusive: true,
          test: value => {
            if (!value || typeof value !== 'string') return false;
            return value === password;
          }
        })
      )
  })
  .noUnknown()
  .required();

export type ICitizenResetDto = yup.InferType<typeof citizenResetValidator>;

// Login
export const citizenCreateAccessTokenValidator = yup
  .object({
    email: yup.string().email().lowercase().required().label('E-Mail'),
    password: yup.string().label('Password').required()
  })
  .noUnknown()
  .required();

export type ICitizenCreateAccessTokenDto = yup.InferType<
  typeof citizenCreateAccessTokenValidator
>;

// Registrazione mail
export const citizenMailValidator = yup
  .object({
    email: yup.string().email().lowercase().required().label('E-Mail'),
    privacyAcceptance: yup
      .boolean()
      .required('È necessario accettare la privacy policy')
      .oneOf([true], 'È necessario accettare la privacy policy'),
    token: yup.string().required().label('Token')
  })
  .noUnknown()
  .required();

export type ICitizenMailDto = yup.InferType<typeof citizenMailValidator>;
